// @vue/component
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    bgVariant: {
      type: String
      // default: null
    },
    borderVariant: {
      type: String
      // default: null
    },
    textVariant: {
      type: String
      // default: null
    }
  }
}
